import axios, {AxiosResponse, AxiosError} from 'axios'
import {Request, Response} from 'express'
import {Result} from '../../resultModel'
import {
  COURSES_BY_ID_GETURL,
  COURSE_PATIENT_INFO_BY_COURSEID_GETURL,
  GET_COURSE_BATCH_RESULT_GETURL,
  GET_COURSE_EXCEL_RESULT_GETURL,
  GET_COURSE_STATUS_BY_USERID_GETURL,
} from '../../endpoints'
import {RequestManager} from '../../RequestManager'
import {GetCourseOutput} from './models/getCourseModels'
import {CoursePatientInfo} from './models/getCoursePatientInfoByCourseIdModels'
import {GetCourseBatchDto} from './models/getCourseBatchResult'
import * as XLSX from 'xlsx'

export const getCourse = async () => {
  const requestManager = new RequestManager()

  var res: Result<GetCourseOutput> = {success: false, message: 'Hata', data: null}
  ////debugger
  return requestManager
    .get<Result<GetCourseOutput>>(COURSES_BY_ID_GETURL)
    .then((response) => {
      ////debugger
      res = response
      return res
    })
    .catch((error) => {
      res.message = error.message
      return res
    })
}

export const getCoursePatientInfoByCourseId = async (courseId: number) => {
  const requestManager = new RequestManager()

  var res: Result<CoursePatientInfo[]> = {success: false, message: 'Hata', data: null}
  ////debugger
  return requestManager
    .get<Result<CoursePatientInfo[]>>(COURSE_PATIENT_INFO_BY_COURSEID_GETURL(courseId))
    .then((response) => {
      ////debugger
      res = response
      return res
    })
    .catch((error) => {
      res.message = error.message
      return res
    })
}
export const getCourseStatusByUserId = async (userId: number) => {
  ////debugger
  const requestManager = new RequestManager()

  var res: Result<GetCourseOutput> = {success: false, message: 'Hata', data: null}
  ////debugger
  return requestManager
    .get<Result<GetCourseOutput>>(GET_COURSE_STATUS_BY_USERID_GETURL(userId))
    .then((response) => {
      ////debugger
      res = response
      return res
    })
    .catch((error) => {
      res.message = error.message
      return res
    })
}
export const getCourseBatchResult = async () => {
  ////debugger
  const requestManager = new RequestManager()

  var res: Result<GetCourseBatchDto> = {success: false, message: 'Hata', data: null}
  ////debugger
  return requestManager
    .get<Result<GetCourseBatchDto>>(GET_COURSE_BATCH_RESULT_GETURL)
    .then((response) => {
      ////debugger
      res = response
      return res
    })
    .catch((error) => {
      res.message = error.message
      return res
    })
}
export const getCourseExcelResult = async (type: number) => {
  const res: Result<any> = {success: false, message: 'Hata', data: null}

  try {
    const response = await axios.get(GET_COURSE_EXCEL_RESULT_GETURL(type), {
      responseType: 'arraybuffer', // Dosyayı binary olarak almak için gerekli
    })

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })

    const fileName = 'Results.xlsx'
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = fileName
    a.click()
    window.URL.revokeObjectURL(url)

    res.success = true
    return res
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError
      console.error('Axios Hatası:', axiosError.message)
    } else {
      console.error('Bilinmeyen Hata:', error)
    }

    res.message = 'Bilinmeyen hata'
    return res
  }
}
/*
export const getCourseExcelResult = async () => {
  ////debugger
  const requestManager = new RequestManager()

  var res: Result<any> = {success: false, message: 'Hata', data: null}
  //debugger
  //const CHUNK_SIZE = 1024 * 1024 // 1 MB'lık parçalarla okuma
  return (
    requestManager
      .get<Blob>(GET_COURSE_EXCEL_RESULT_GETURL)
      // .then((response) => {
      //   // // API'den gelen Excel dosyasını indirin
      //   // //debugger
      //   // console.log(JSON.stringify(response))
      //   // const blob = new Blob([response], {
      //   //   type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      //   // })
      //   // const url = window.URL.createObjectURL(blob)
      //   // const a = document.createElement('a')
      //   // a.href = url
      //   // a.download = 'Result.xlsx' // İndirilen dosyanın adı
      //   // a.click()
      //   // window.URL.revokeObjectURL(url)
      //   const url = window.URL.createObjectURL(new Blob([response.data]))
      //   const link = document.createElement('a')
      //   link.href = url
      //   link.setAttribute('download', 'data.xlsx')
      //   document.body.appendChild(link)
      //   link.click()
      //   return {success: true, message: '', data: null}
      // })// ...

      // .then((response) => {
      //   const blob = new Blob([response], {
      //     type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      //   })
      //   debugger
      //   const reader = new FileReader()

      //   reader.onload = () => {
      //     const arrayBuffer = reader.result as ArrayBuffer | null
      //     console.log(arrayBuffer)
      //     // arrayBuffer null değilse işleme devam et
      //     if (arrayBuffer) {
      //       // Dosya parçalara bölünerek işlenebilir
      //       for (let offset = 0; offset < arrayBuffer.byteLength; offset += CHUNK_SIZE) {
      //         const chunk = arrayBuffer.slice(offset, offset + CHUNK_SIZE)
      //         console.log(chunk)
      //         debugger
      //         // Dosya parçasını işleme al
      //         const workbook = XLSX.read(chunk, {type: 'array'})
      //         // İşlemlerinize devam edin...

      //         const firstSheetName = workbook.SheetNames[0]
      //         const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheetName])
      //         console.log(sheetData)
      //       }
      //     }
      //   }

      //   reader.readAsArrayBuffer(blob)
      //   // Diğer işlemler...
      // })

      .then((response) => {
        debugger
        console.log(response)
        // Excel dosyasını indirmek için bir Blob oluşturun
        const blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })
        console.log(blob)
        debugger
        // Blob'u URL'e dönüştürün
        const url = window.URL.createObjectURL(blob)
        console.log(url)
        debugger
        // Dosya adını belirleyin
        const fileName = 'Results.xlsx'

        // Anchor elementi oluşturun ve Excel dosyasını indirme bağlantısını ekleyin
        const a = document.createElement('a')
        a.href = url
        a.download = fileName
        console.log(a)
        debugger
        // Anchor elementini tıklama ile tetikleyin
        a.click()

        // URL nesnesini temizleyin
        window.URL.revokeObjectURL(url)
      })

      .catch((error) => {
        res.message = error.message
        return res
      })
  )
}
*/
